import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { LoadingController, MenuController, NavController } from '@ionic/angular';
import { CarritoService } from 'src/app/services/carrito/carrito.service';

import { GlobalConstants } from 'src/app/services/globalConstants/global-constants.service';
import { GlobalFunctionsService } from 'src/app/services/globalFunctions/global-functions.service';
import { StorageService } from 'src/app/services/storage/storage.service';

import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { VisitaService } from 'src/app/services/visita/visita.service';

@Component({
  selector: 'app-recovery',
  templateUrl: './recovery.page.html',
  styleUrls: ['./recovery.page.scss'],
})
export class RecoveryPage implements OnInit {

  //#region Propiedades

  public _appVersion: string;

  public _utmCampaign: string = null;
  public _utmContent: string = null;
  public _utmMedium: string = null;
  public _utmSource: string = null;
  public _utmTerm: string = null;
  public _enviando: boolean = false;
  public _validando: boolean = false;
  public _userPassword: string = '';
  public _userConfirmPassword: string = '';
  public codeValido: number;
  public tokenRecovery: string;

  //#endregion Propiedades

  //#region Constructor

  constructor(private _route: ActivatedRoute,
              private _menuCtrl: MenuController,
              private _usuarioSrv: UsuarioService,
              private _visitaSrv: VisitaService,
              public storage: StorageService,
              private _navCtrl: NavController,
              public _loadingCtrl: LoadingController,
              private _globalFunctionsSrv: GlobalFunctionsService) {

    console.log('RecoveryPage >> constructor');

  }

  //#endregion Constructor

  //#region Eventos NG

  public ngOnInit() {
    this._menuCtrl.enable(false);
  }

  public async ionViewDidEnter() {
    console.log('RecoveryPage >> ionViewDidEnter');
    this._enviando = false;
    this._validando = false;
    this._appVersion = GlobalConstants.APP_VERSION;

    // recupera/crea/guarda token publico
    await this._usuarioSrv.doPublicToken();

    // registra visita
    await this._route.queryParams.subscribe((params) => {

      if (params['c'] !== undefined) {
        this.tokenRecovery = params['c'];
        console.log('validar codigo: ' + params['c']);
        this.validaToken(params['c']);

      }  else { // no trae query params...redirige pagina principal de categorias
        this._navCtrl.navigateForward('/categoria');
      }

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardar('Recovery', null, null,
      null, null, null, null,
      null, null,
      this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm).subscribe();
    });

  }

  public validaToken(code){
    this._loadingCtrl.create({ // crea 'wait' como promise
      spinner: 'crescent',
      cssClass: 'loading',
      message: 'Espere...',
    }).then(async (loading) => {
      loading.present();
      this._usuarioSrv.validaRecovery(code).subscribe(res => {
              this.codeValido = this._usuarioSrv.RecoveryValido;
              console.log(this._usuarioSrv.RecoveryValido);
              loading.dismiss();
            } , (error) => { // Error al obtener los datos
              loading.dismiss();
            });
      });
  }

  //#endregion Eventos NG

  //#region Eventos Botones

  public async updatePassword(e: Event){
    if (this._userPassword !== '' && this._userConfirmPassword !== ''){
      if (this._userPassword !== this._userConfirmPassword){
        this._globalFunctionsSrv.showMessageToast('Las contraseñas no coinciden.');
      }
      else{
        this._validando = true;
        this._globalFunctionsSrv.showLoader();
        this._usuarioSrv.updatePassword(this._userPassword, this.tokenRecovery).subscribe(() => {
          console.log('resp login:', this._usuarioSrv.PasswordActualizado);
          if (this._usuarioSrv.PasswordActualizado == 1){
            this._globalFunctionsSrv.hideLoader();
            this._globalFunctionsSrv.showMessageToast('Contraseña actualizada correctamente.');
            this.codeValido = 2;
          }
          else{
            this._globalFunctionsSrv.hideLoader();
            this._globalFunctionsSrv.showMessageToast('No e pudo actualizar la contraseña en este momento, intente de nuevo más tarde.');
          }
          this._validando = false;
        });
      }
    }
    else{
      this._globalFunctionsSrv.showMessageToast('Debe ingresar su nueva contraseña y la confirmación.');
    }

  }

  //#endregion

}
